import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

/**
* Получение информации по всем городам.
* @link https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%93%D0%95%D0%9E/48be3ae7afca61dc4db4c977c3115c60
*/
const getAllCities = (isAll: RequestDto): IRequest => {
    return {
        uri: '/v1/geography/get-all-cities',
        method: 'GET',
        queryParams: {
            all: isAll,
        },
    };
};

export type { ResponseDto } from './dto/ResponseDto';

export default getAllCities;
